import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { IPassword } from 'src/interfaces/Users/RegisterInterfaces';
import FormModel from 'src/models/forms/FormModel';
import InputDefinitionBuilder from '../../../../utils/inputDefinitions/InputDefinitionBuilder';
import StandardTextBoxField from '../../textbox/StandardTextBoxField';
import { IInputFieldProps } from '../common/IInputFieldProps';

interface IPasswordField extends IInputFieldProps {
  model: IPassword & FormModel;
}

const PasswordField: React.FC<IPasswordField> = (props: IPasswordField) => {
  const [inputDefinition] = React.useState(() => {
    return new InputDefinitionBuilder('Password')
      .WithPlaceholder('Password')
      .WithRequiredTextBoxField()
      .WithMinLength(6, 'Must be at least 6 characters')
      .Build();
  });
  return (
    <StandardTextBoxField
      name='password'
      value={props.model.password}
      onModelChange={props.model.OnModelChange}
      inputDefinition={inputDefinition}
      type='password'
      noStyle={props.noStyle}
    />
  );
};

export default observer(PasswordField);
